import { Filter, RuleOperator } from 'src/app/modules/core/store/models/filters.model';
import { IFieldFilterHandler, FieldFilterHandler } from 'src/app/modules/core/services/filter-runtime/field-handlers';

export class DateTimeFieldFilterHandler extends FieldFilterHandler implements IFieldFilterHandler {
  constructor() {
    super();
  }

  fieldMatchesFilter(value: any, filter: Filter): boolean {
    let operator = filter.operator;
    if (operator === RuleOperator.GreaterThan || operator === RuleOperator.GreaterThanEqualTo) {
      operator = RuleOperator.DateIsGreaterThan;
    } else if (operator === RuleOperator.LessThan || operator === RuleOperator.LessThanEqualTo) {
      operator = RuleOperator.DateIsLessThan;
    }

    const handler = this.comparisonHandlers[operator];

    if (!handler) {
      return true;
    }

    const doesMatch = handler(value, filter);

    return doesMatch;
  }
}
